import {
  Asset,
  Item,
  Kit,
  KitVersion,
  LingoError,
  Portal,
  Product,
  ProductType,
  Section,
  Space,
  User,
} from "@thenounproject/lingo-core";

export enum NavPointTypes {
  "LibraryAsset" = "LibraryAsset",
  "Item" = "Item",
  "Gallery" = "Gallery",
  "Section" = "Section",
  "Kit" = "Kit",
  "KitVersions" = "KitVersions",
  "KitTrashedItems" = "KitTrashedItems",
  "UserSettings" = "UserSettings",
  "SpaceBilling" = "SpaceBilling",
  "SpaceSearch" = "SpaceSearch",
  "SpaceSettings" = "SpaceSettings",
  "SpaceUsers" = "SpaceUsers",
  "Insights" = "Insights",
  "NewSpace" = "NewSpace",
  "SpaceKits" = "SpaceKits",
  "KitCollection" = "KitCollection",
  "DefaultSpace" = "DefaultSpace",
  "Library" = "Library",
  "TagManagement" = "TagManagement",
  "CustomFields" = "CustomFields",
  "KitRecoveredAssets" = "KitRecoveredAssets",
  "Dashboard" = "Dashboard",
  "Portal" = "Portal",
  "Products" = "Products",
  "ProductDetail" = "ProductDetail",
  "Markets" = "Markets",
  "Integrations" = "Integrations",
  "ProductTypes" = "ProductTypes",
  "ProductTypeDetail" = "ProductTypeDetail",
}

export type NavPoint = {
  type: NavPointTypes;
  loaded?: boolean;
  error?: LingoError;
  subdomain?: string;
  spaceId?: number;
  space?: Space;
  version?: number;
  role?: string;
  name?: string;
  portalId?: string;
  portal?: Portal;
  kitId?: string;
  kit?: Kit;
  kitVersion?: KitVersion;
  kitCollectionId?: string;
  sectionId?: string;
  section?: Section;
  galleryId?: string;
  gallery?: Item;
  itemId?: string;
  item?: Item;
  asset?: Asset;
  assetId?: string;
  assetToken?: string;
  productId?: string;
  product?: Product;
  productTypeId?: string;
  productType?: ProductType;
  insightsPage?: string;
  galleryContext?: string;
  settingsPage?: string;
  search?: string;
  user?: User;
};
